<script>
    import { createEventDispatcher } from "svelte";
    import Button from "../ui/Button.svelte";
    import AddDevice from "./AddDevice.svelte";
    import DeviceItem from "./DeviceItem.svelte";
    export let devices;

    const dispatch = createEventDispatcher();
</script>

<div class="list">
    {#each devices as device (device.id)}
        <DeviceItem bind:device={device} on:remove={(e) => dispatch("remove", e.detail)} on:edit={(e) => dispatch("edit", e.detail)}/>
    {/each}
    <AddDevice on:add={(e) => dispatch("add", e.detail)}/>
</div>

<style>
    .list {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
    }
</style>